<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">

                <div class="form-row">
                    <div class="col-md-11">
                        <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.trucker.list.label.title')}}</h4></h4>
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>

               <p class="sub-header">
                    {{$t('string.msg.trucker.search.description')}}
                </p>
      

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputAddress" class="col-form-label">
                                {{$t('string.msg.trucker.search.label.name')}}
                            </label>
                               <input type="text" v-model="filters.name" class="form-control">
                        </div>
                         
                    </div>

                    <br/>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter()" class="btn btn-success w-20">{{$t('string.msg.form.btn.search')}}</button>
                        <download-excel v-if="items && items.length>0"
                            class   = "btn btn-primary"
                            :fetch   = "fetchData"
                            :fields = "json_fields"
                            type    = "csv"
                            name    = "truckers.xls">
	                        Download CSV
                        </download-excel>
                    </div>
                    
                </form>

                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.cnh')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.company')}}</th>
                                <th class="border-top-0">{{$t('string.msg.trucker.table.header.occupation')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer" @click="selectItem(item)">
                            <tr v-if="item.status!='ARCHIVED'">
                                <td>
                                    <span>
                                        {{camelize(item.firstName) +' ' + camelize(item.lastName)}}
                                    </span>
                                </td>
                                 <td>
                                    <span>
                                        {{item.customerUser.cnh}}
                                    </span>
                                </td>
                                 <td>
                                    <span v-if="item.customerUser.company">   
                                        {{camelize(item.customerUser.company.fantasyName)}}
                                    </span>
                                </td>
                                 <td >
                                    <span v-if="item.status=='WAITING_FOR_APPROVAL'" style="color:orange">
                                        {{toUpperCase($t('string.msg.waiting.for.aprove'))}}
                                    </span>
                                    <span v-if="item.status=='ACTIVE'" style="color:green">
                                        {{toUpperCase($t('string.msg.waiting.for.active'))}}
                                    </span>
                                    <span v-if="item.status=='REJECTED'" style="color:red">
                                        {{toUpperCase($t('string.msg.waiting.for.rejected'))}}
                                    </span>
                                </td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtListTrucker';
import Spinner from '../../../../components/layout/Spinner';
import Toast from '../../../../components/layout/Toast';
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
Vue.prototype.$eventHub = new Vue();
Vue.component('downloadExcel', JsonExcel)

export default {
  name: 'ListTrucker',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
    
    
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        json_fields: {
            'Nome': 'firstName',
            'Sobrenome': 'lastName',
            'Telefone': 'primaryPhone',
            'Email': 'email',
            'Data de Nasc': 'customerUser.dateBirth',
            'CPF': 'customerUser.document',
            'RG': 'customerUser.rg',
            'CNH': 'customerUser.cnh',
            
        },
        json_data: [
            {
                firstName: null,   
                lastName: null,        
                primaryPhone: null,
                email: null,
                customerUser:{
                    dateBirth: null,
                    document: null,
                    cnh: null,
                    rg: null,
                }
            }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
        filters: {
            status:'',
            company: null,
            name: '',
        },
    }
  },
    methods: Controller.methods,
    created() {
       Controller.init(this);
       let state = this;
        this.$eventHub.$on('refreshList', function(){
            state.filter();
        })
    },
    mounted(){

  },
  }

</script>

<style>
</style>